import * as Types from '../../types/generated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PostProfileReportMutationVariables = Types.Exact<{
  input: Types.ReportProfileInput;
}>;

export type PostProfileReportMutation = {
  reportProfile?: { profileSlug: string } | null;
};

export const PostProfileReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PostProfileReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReportProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profileSlug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PostProfileReportMutationFn = Apollo.MutationFunction<
  PostProfileReportMutation,
  PostProfileReportMutationVariables
>;

/**
 * __usePostProfileReportMutation__
 *
 * To run a mutation, you first call `usePostProfileReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostProfileReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postProfileReportMutation, { data, loading, error }] = usePostProfileReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostProfileReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PostProfileReportMutation,
    PostProfileReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PostProfileReportMutation,
    PostProfileReportMutationVariables
  >(PostProfileReportDocument, options);
}
export type PostProfileReportMutationHookResult = ReturnType<
  typeof usePostProfileReportMutation
>;
export type PostProfileReportMutationResult =
  Apollo.MutationResult<PostProfileReportMutation>;
export type PostProfileReportMutationOptions = Apollo.BaseMutationOptions<
  PostProfileReportMutation,
  PostProfileReportMutationVariables
>;
